import { defineComponent, watch } from 'vue';
import { Animation } from '@/Animation';
export default defineComponent({
    name: 'Messagebar',
    props: {
        message: {
            type: String,
            required: true,
            default: ''
        },
        top_position: {
            type: Boolean,
            default: false
        },
        sound: {
            type: Boolean,
            default: true
        },
        animation: {
            type: Boolean,
            default: true
        }
    },
    setup(props) {
        const message_sound = new Audio(require('@/assets/sound/icq.mp3'));
        watch(() => props.message, (newVal, oldVal) => {
            if (props.top_position) {
                Animation.animateMessageBar('.messagebar_intern', () => { });
            }
            else if (props.sound && newVal !== '' && newVal !== oldVal) {
                message_sound.play();
            }
        });
    }
});
